module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-18.203ee252.png";